<div
    #root
    class="agpr-datePicker"
>
    <div
        #container
        class="agpr-datePicker-fieldContainer"
        [ngClass]="{
            'agpr-datePicker-fieldContainer--focused': inputHasFocus,
            'agpr-datePicker-fieldContainer--disabled': disabled
        }"
    >
        @if (showIcon) {
            <button
                class="agpr-datePicker-toggleButton"
                [ngClass]="icon"
                type="button"
                [attr.aria-disabled]="disabled"
                [agprTooltip]="!disabled ? 'Common.datePicker.openCalendar' : null"
                tooltipPosition="top"
                [useTooltipAsAriaLabel]="false"
                [attr.aria-label]="iconAriaLabel"
                [attr.aria-expanded]="overlayVisible"
                (click)="togglePanel()"
            ></button>
        }

        <input
            #inputField
            type="text"
            [id]="id + '_inputField'"
            class="agpr-datePicker-input"
            [attr.name]="name"
            [attr.required]="required"
            [disabled]="disabled"
            [readonly]="readonlyInput"
            [attr.tabindex]="tabindex"
            autocomplete="off"
            [placeholder]="(placeholder || '') | localize"
            [attr.aria-label]="'date' | localize"
            [attr.aria-labelledby]="ariaLabelledBy"
            [value]="inputFieldValue"
            (focus)="onInputFocus($event)"
            (blur)="onInputBlur($event)"
            (input)="onUserInput($event)"
            (keydown)="onInputKeydown($event)"
            (keyup)="handleKeyup($event)"
        />
    </div>

    @if (!hideFormatHint) {
        <i class="agpr-datePicker-formatHint">{{ formatHint }}</i>
    }

    <!-- anchored to #root so the overlay sits below the format hint, as before -->
    <agpr-date-picker-overlay
        #overlay
        [anchor]="root"
        [panelStyleClass]="panelStyleClass"
        (opened)="onOverlayOpened($event)"
        (closed)="onOverlayClosed($event)"
        (escape)="closePanelAndFocusInput()"
        (outsideClick)="clickOutside.emit($event)"
    >
        <ng-content select="p-header"></ng-content>

        <agpr-date-picker-panel
            #panel
            [value]="value"
            [selectionMode]="selectionMode"
            [view]="view"
            [defaultDate]="defaultDate"
            [minDate]="minDate"
            [maxDate]="maxDate"
            [disabledDates]="disabledDates"
            [disabledDays]="disabledDays"
            [disabled]="disabled"
            (valueChange)="onPanelValueChange($event)"
            (dateSelect)="onPanelDateSelect($event)"
            (monthChange)="monthChange.emit($event)"
            (yearChange)="yearChange.emit($event)"
        ></agpr-date-picker-panel>

        <ng-content select="p-footer"></ng-content>

    </agpr-date-picker-overlay>
</div>
